import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

/**
 * Feature flag hook for AI Skills functionality.
 *
 * Controls whether users see:
 * - RichTextInput with /skill blocks (enabled) vs plain textarea (disabled)
 * - SkillSelector dropdown (enabled) vs hidden (disabled)
 * - SkillAutocomplete popup (enabled) vs hidden (disabled)
 *
 * Uses Flipt feature flag "agent-skills" to determine enablement.
 * Default: false (disabled by default, enabled per user via segment)
 *
 * @returns true if skills feature is enabled for the current user, false otherwise
 */
export function useSkillsFeature(): boolean {
  const user = useUser();
  return useFliptBoolean("agent-skills", false, user?.email);
}
